import { httpClient } from "../http-client";

export type SsoProtocol = "saml" | "oidc";
export type SsoProvider =
  | "okta"
  | "azure_ad"
  | "google"
  | "onelogin"
  | "adfs"
  | "custom";

export interface SsoConfiguration {
  id: string;
  name: string;
  protocol: SsoProtocol;
  provider: SsoProvider;
  isActive: boolean;
  jitProvisioningEnabled: boolean;
  allowedDomains?: string[];
  spEntityId?: string;
  spCallbackUrl?: string;
  createdAt: string;
}

export interface CreateSsoConfigurationRequest {
  name: string;
  protocol: SsoProtocol;
  provider?: SsoProvider;
  samlConfig?: {
    entryPoint: string;
    issuer: string;
    cert: string;
    signatureAlgorithm?: string;
  };
  oidcConfig?: {
    issuer: string;
    clientId: string;
    clientSecret: string;
    scope?: string;
    authorizationUrl?: string;
    tokenUrl?: string;
    userInfoUrl?: string;
  };
  attributeMapping?: {
    email: string;
    firstName?: string;
    lastName?: string;
    roles?: string;
  };
  roleMapping?: Array<{ idpRole: string; eventosRole: string }>;
  jitProvisioningEnabled?: boolean;
  forceAuthentication?: boolean;
  defaultRole?: string;
  allowedDomains?: string[];
  isActive?: boolean;
  spEntityId?: string;
  spCallbackUrl?: string;
}

const BASE = "/auth/sso";

export const ssoApi = {
  listConfigurations: () =>
    httpClient.get<SsoConfiguration[]>(`${BASE}/configurations`),

  getConfiguration: (id: string) =>
    httpClient.get<SsoConfiguration>(`${BASE}/configurations/${id}`),

  createConfiguration: (data: CreateSsoConfigurationRequest) =>
    httpClient.post<SsoConfiguration>(`${BASE}/configurations`, data),

  updateConfiguration: (
    id: string,
    data: Partial<CreateSsoConfigurationRequest>,
  ) => httpClient.put<SsoConfiguration>(`${BASE}/configurations/${id}`, data),

  deleteConfiguration: (id: string) =>
    httpClient.delete(`${BASE}/configurations/${id}`),

  testConfiguration: (id: string) =>
    httpClient.post<{ success: boolean; message: string }>(
      `${BASE}/configurations/${id}/test`,
      {},
    ),

  getSamlMetadataUrl: (configId: string) => `${BASE}/saml/${configId}/metadata`,

  getSamlLoginUrl: (configId: string) => `${BASE}/saml/${configId}/login`,

  getOidcLoginUrl: (configId: string) => `${BASE}/oidc/${configId}/login`,
};
